<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="修改首页科学组织" name="1">
      <FirScienceAdd :updataID='updataID'></FirScienceAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 首页科学组织修改
 */
import FirScienceAdd from '../../../../static/form/FirScienceAdd.vue'
export default {
  components: {
    FirScienceAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/FirInfo'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/FirScienceUpdate.vue